module.exports = __webpack_public_path__ + "img/jobNotFound.e473b680.svg";